import ReactHtmlParser from 'html-react-parser';

const Card = (props) => {
  const { title, text, link, image, colorBg, colorText } = props;

  const colorTextFinal = colorText ? colorText : "text-neutral-50";

  const onButton = () => {
    props.contentMenu();
    props.openMenu();
  };

  const img = <div
  style={{backgroundImage: "url('"+image+"')", backgroundPositionX: "center"}}
  className={"rounded-t-lg h-[100px] w-full bg-cover bg-no-repeat "+colorBg}
></div>;

  return (
    <>
      <div
        className={
          "flex flex-col text-left rounded-lg w-96 m-5 " +
          colorBg +
          " shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)]"
        }
      >
        {typeof link == 'string' && <a target="_blank" href={link}>
          {img}
        </a> }
        {typeof link != 'string' && <span onClick={onButton}>
          {img}
        </span> }
        <div className="p-6 flex flex-col flex-1">
          <div className="flex-1">
          <h5 className={"mb-2 text-xl font-medium leading-tight "+colorTextFinal}>
            {title}
          </h5>
          <p className={"mb-4 text-base "+colorTextFinal}>
            {ReactHtmlParser(text)}
          </p></div>
          {typeof link == "string" && (
            <a target="_blank" href={link} className="h-10">
              <button
                type="button"
                className="inline-block w-full bg-white rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-black shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
              >
                Open
              </button>
            </a>
          )}
          {typeof link != "string" && (
            <button
              type="button"
              onClick={onButton}
              className="h-10 inline-block w-full bg-white rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-black shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
            >
              Open menu
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Card;
